'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemsListSchema = undefined;

var _normalizr = require('normalizr');

var itemSchema = new _normalizr.schema.Entity('items');
var itemsListSchema = exports.itemsListSchema = [itemSchema];


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/data/schemas.js
// module id = 155
// module chunks = 5